var map = {
	"./quiz-pic-0.jpeg": 1480,
	"./quiz-pic-1.jpeg": 1481,
	"./quiz-pic-2.jpeg": 1482,
	"./quiz-pic-3.jpeg": 1483,
	"./quiz-pic-4.jpeg": 1484,
	"./quiz-pic-5.jpeg": 1485,
	"./quiz-pic-6.jpeg": 1486,
	"./quiz-pic-7.jpeg": 1487,
	"./quiz-pic-8.jpeg": 1488,
	"./quiz-pic-9.jpeg": 1489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1479;